import "./TemporaryRoofs.module.css";
import Header from "@/reusable_sections/Header";
import TemporaryRoofs from "./sections/TemporaryRoofs";
import RelatedServices from "./sections/RelatedServices";
import Footer from "@/reusable_sections/Footer";
export default function TemporaryRoofsPage() {
  return <div>
      <Header />
      <TemporaryRoofs />
      <RelatedServices />
      <Footer />
    </div>;
}